import { Button, Col, Row, Space, Spin, Tooltip } from 'antd'
import { Actions } from '../../modules/sbrm/components/Actions'
import { SBRMType } from '../../modules/sbrm/SBRMModel'
import PageTitle from '../../components/PageTitle'
import {
  EditOutlined,
  QuestionCircleOutlined,
  QuestionOutlined,
  SaveOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  getAutomationWithId,
  selectSelectedAutomation,
} from '../../store/AutomationReducer'
import { Answer } from '../../components/answer/Answer'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import Gleap from 'gleap'

const AutomationPage = () => {
  const dispatch = useAppDispatch()
  const automation = useAppSelector(selectSelectedAutomation())

  const { isOpen: SBRMIsOpen } = useAppSelector((state) => state.SBRM)
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)
  const [editingAnswers, setEditingAnswers] = useState<boolean>(false)

  useEffect(() => {
    if ((!isFirstRender && SBRMIsOpen) || !automation) {
      return
    }
    setIsFirstRender(false)
    if (automation.id) {
      dispatch(getAutomationWithId(automation.id))
    }
  }, [SBRMIsOpen])

  if (!automation) {
    return (
      <Row gutter={[16, 26]}>
        <Col span={24} style={{ alignContent: 'center' }}>
          <Spin />
        </Col>
      </Row>
    )
  }

  return (
    <Row gutter={[16, 26]}>
      <Col span={24}>
        <PageTitle
          type="sympa"
          title={i18n.t(LocalizationKeys.Page.AutomationPage.Title)}
          toolbar={
            <Space>
              <Actions
                entity={SBRMType.automation}
                actions={['update']}
                entityId={automation.id}
                trigger={
                  <Button
                    icon={<SettingOutlined />}
                    className="gleap-automation-settings"
                  >
                    {i18n.t(LocalizationKeys.Page.AutomationPage.Settings)}
                  </Button>
                }
              />
              <Button
                className="gleap-automation-edit-and-save"
                type={'primary'}
                icon={editingAnswers ? <SaveOutlined /> : <EditOutlined />}
                onClick={() => setEditingAnswers(!editingAnswers)}
              >
                {i18n.t(
                  editingAnswers
                    ? LocalizationKeys.Page.AutomationPage.Save
                    : LocalizationKeys.Page.AutomationPage.Edit
                )}
              </Button>
              <Tooltip title={i18n.t(LocalizationKeys.Misc.Button.Help)}>
                <Button
                  icon={<QuestionCircleOutlined />}
                  onClick={() => Gleap.openHelpCenterCollection('1', false)}
                />
              </Tooltip>
            </Space>
          }
        />
      </Col>
      <Col span={24}>
        <Answer.Card
          automation={automation}
          forFollower={true}
          isEditing={editingAnswers}
        />
      </Col>
      <Col span={24}>
        <Answer.Card
          automation={automation}
          forFollower={false}
          isEditing={editingAnswers}
        />
      </Col>
    </Row>
  )
}

export default AutomationPage
